import Joi from 'joi';
import { HOST_SECOND } from "common-import/constants";
import { Request } from "common-import/helpers";
// import * as Validator from "./Notify.Validator"

class NotifyAPI {
  /*
    method: POST
    url: /notification/user/:userId/info
    headers: {
      content-type: application/json
      Authorization: string required
    },
    body: {
      add: token string // Note: Dùng khi được cấp token, hoặc refresh token
      remove: token string // Note: Dùng để remove token cũ, khi user logout, khi token hết hạn phải refresh
    }
  * */

  setup = async (user_id, data) => {
    const validator = false;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST_SECOND + `/notification/user/${user_id}/info`, data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*
    method: GET
    url: /notification/user/:userId/list
  * */
  list = async (user_id, data) => {
    const validator = false;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.get(HOST_SECOND + `/notification/user/${user_id}/list`, data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*
    method: DELETE
    url: /notification/user/:userId/clear

    notiId: string id
  * */

  markAll = async (data) => {
    const validator = false;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.delete(HOST_SECOND + `/notification/user/${data.userId}/clear`, data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  markOne = async (data) => {
    const validator = false;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.delete(HOST_SECOND + `/notification/user/${data.userId}/clear?notiId=${data.notiId}`, data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*
    method: POST
    url: /notification/rule/new/share_project

    body:
      project:
        id
        name
      objects: array of string email
      subject:
        note
        id
        name
  * */

  projectShare = async (data) => {
    const validator = false;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST_SECOND + `/notification/rule/new/share_project`, data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*
    method: POST
    url: /notification/rule/new/activate-user

    email: string
  * */

  activeAccount = async (data) => {
    const validator = false;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST_SECOND + `/account/activate`, data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };
}

export default new NotifyAPI();



// WEBPACK FOOTER //
// ./src/services/notify/Notify.API.js